import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Baby, Edit, Trash2 } from 'lucide-react';
import { Pagination } from '@/components/shared/Pagination';

export const BirthCardsView = ({ paginatedBirths, getSheepById, sheep, canWrite, canDelete, openEditDialog, handleDelete, currentPage, totalPages, onPageChange, startIndex, itemsPerPage, totalItems }) => (
  <Card className="border-0 shadow-md">
    <CardHeader><CardTitle className="text-xl">Naissances en cartes</CardTitle></CardHeader>
    <CardContent>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {paginatedBirths.length === 0 ? (
          <div className="col-span-full text-center py-12 text-gray-500 dark:text-gray-400">
            <Baby className="w-12 h-12 mx-auto mb-3 text-gray-300" />
            <p>Aucune naissance enregistrée</p>
          </div>
        ) : paginatedBirths.map((birth) => {
          const mere = getSheepById(birth.mere_id);
          const isOverdue = birth.statut === 'prevue' && new Date(birth.date_prevue) < new Date();
          return (
            <Card key={birth.id} className={`border-l-4 hover:shadow-lg transition-shadow ${
              birth.statut === 'ne' ? 'border-l-green-500' : isOverdue ? 'border-l-red-500' : 'border-l-blue-500'
            }`}>
              <CardContent className="p-4 space-y-3">
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <div className="font-semibold text-gray-900 dark:text-white">
                      {mere ? `N\u00b0 ${mere.numero} ${mere.nom || ''}`.trim() : 'Mère inconnue'}
                    </div>
                    <div className="text-sm text-gray-600 mt-1">
                      Prévue le {new Date(birth.date_prevue).toLocaleDateString('fr-FR')}
                    </div>
                    {birth.date_reelle && (
                      <div className="text-sm text-green-600 mt-1">
                        Née le {new Date(birth.date_reelle).toLocaleDateString('fr-FR')}
                      </div>
                    )}
                  </div>
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    birth.statut === 'ne' ? 'bg-green-100 text-green-700' :
                    isOverdue ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'
                  }`}>
                    {birth.statut === 'prevue' ? (isOverdue ? 'Retard' : 'Prévue') : 
                     birth.statut === 'ne' ? 'Née' : birth.statut}
                  </span>
                </div>

                {birth.notes && (
                  <div className="text-sm text-gray-600 bg-gray-50 dark:bg-gray-950 p-2 rounded">{birth.notes}</div>
                )}

                <div className="text-sm">
                  <span className="text-gray-600 dark:text-gray-400">
                    {(birth.agneaux_ids?.length || 0) + (birth.agneaux_morts || 0)} agneau(x)
                    {birth.agneaux_morts > 0 && (
                      <span className="text-red-600 ml-2">({birth.agneaux_morts} mort(s))</span>
                    )}
                  </span>
                  {birth.agneaux_ids && birth.agneaux_ids.length > 0 && (
                    <div className="flex flex-wrap gap-1 mt-2">
                      {birth.agneaux_ids.map(aid => {
                        const linkedSheep = sheep.find(s => s.id === aid);
                        return linkedSheep ? (
                          <span key={aid} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${
                            linkedSheep.statut === 'mort' ? 'bg-red-100 text-red-700' : 
                            linkedSheep.statut === 'vendu' ? 'bg-amber-100 text-amber-700' : 
                            'bg-green-100 text-green-700'
                          }`} title={`${linkedSheep.numero} - ${linkedSheep.nom || 'Sans nom'} (${linkedSheep.statut})`}>
                            {linkedSheep.numero}
                            {linkedSheep.statut === 'mort' && ' \u2020'}
                            {linkedSheep.statut === 'vendu' && ' $'}
                            {linkedSheep.statut === 'actif' && ' \u2713'}
                          </span>
                        ) : null;
                      })}
                    </div>
                  )}
                </div>

                {(canWrite || canDelete) && (
                  <div className="flex gap-2 pt-2 border-t border-gray-100">
                    {canWrite && <Button variant="outline" size="sm" onClick={() => openEditDialog(birth)} className="flex-1 text-blue-600 border-blue-200 hover:bg-blue-50"><Edit className="w-4 h-4 mr-2" />Modifier</Button>}
                    {canDelete && <Button variant="outline" size="sm" onClick={() => handleDelete(birth.id)} className="text-red-600 border-red-200 hover:bg-red-50"><Trash2 className="w-4 h-4" /></Button>}
                  </div>
                )}
              </CardContent>
            </Card>
          );
        })}
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} startIndex={startIndex} itemsPerPage={itemsPerPage} totalItems={totalItems} label="naissances" />
    </CardContent>
  </Card>
);
